export default __webpack_public_path__ + "static/media/Self_Defence2.23c9d953.jpg";